import React from 'react';
import EditSeriesModal from './edit-series-modal';
import { ActionContainer, ActionLink, ActionTitle } from '../../shared/styles';

export default function Actions() {
  const editSeriesModalRef = React.useRef();

  const createSeries = e => {
    e && e.preventDefault();

    editSeriesModalRef.current && editSeriesModalRef.current.present();
  };

  return (
    <>
      <ActionContainer>
        <ActionTitle>Tools</ActionTitle>
        <ActionLink href="/lwadmin/series/configuration">Configuration</ActionLink>
        <ActionLink href="#" onClick={createSeries}>Create series</ActionLink>
      </ActionContainer>
      <EditSeriesModal
        ref={editSeriesModalRef}
        seriesDidSave={() => window.location.reload()}
      />
    </>
  );
}
